import produce from 'immer';
import {State, Actions} from './interfaces';
import {
  GET_ORDERS,
  GET_ORDERS_FAILED,
  GET_ORDERS_SUCCESS,
  CHANGE_ORDER_STATUS,
  CHANGE_ORDER_STATUS_FAILED,
  CHANGE_ORDER_STATUS_SUCCESS,
} from './constants';

export const initialState: State = {
  error: '',
  loading: false,
  count: 0,
  ordersList: [],
};

export const DriverReducer = (state = initialState, action: Actions) =>
  produce(state, draft => {
    switch (action.type) {
      case GET_ORDERS:
        draft.loading = true;
        break;
      case GET_ORDERS_SUCCESS:
        draft.ordersList = action.data;
        draft.count = action.count;
        break;
      case GET_ORDERS_FAILED:
        draft.error = action.error;
        draft.loading = false;
        break;
      case CHANGE_ORDER_STATUS:
        draft.loading = false;
        break;
      case CHANGE_ORDER_STATUS_FAILED:
        draft.error = action.error;
        draft.loading = false;
        break;
      case CHANGE_ORDER_STATUS_SUCCESS:
        draft.loading = false;
        break;
      default:
        break;
    }
  });
export default DriverReducer;
